import { MousePointer2 } from "lucide-react";
import { createLucideIcon } from "./createLucideIcon";

export const MousePointer2Icon = createLucideIcon(MousePointer2);
